import React from 'react'
import { Grid, Heading, Button } from '@design-systems/canvas-ui'
import styles from './ErrorPage.module.css'

const ErrorPage = () => {
  return (
    <Grid.Container direction="column" align="center" role="alert">
      <Grid.Item size={{ xs: 12 }} className="hc8-mb-3x">
        {/* not using canvas image to have a little better control of the image styling */}
        <div className={styles.image} role="presentation" />
      </Grid.Item>
      <Grid.Item>
        <Heading size={5}>
          Pardon our dust, we're working to get things back on track.
        </Heading>
      </Grid.Item>
      <Grid.Item>
        <Button variant="primary" onClick={() => window.location.reload()}>
          Reload
        </Button>
      </Grid.Item>
    </Grid.Container>
  )
}

export default ErrorPage
